<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">

        <el-form-item>
            <el-button type="success" @click="handleAdd">新增</el-button>
        </el-form-item>
        </el-form>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="platformGroupName" label="公司"  width="100"></el-table-column>
                <el-table-column prop="platformName" label="平台" width="100"></el-table-column>
                <el-table-column prop="appid"  label="appid"  width="150"></el-table-column>
                <el-table-column prop="appName" label="appName"  width="100"></el-table-column>
                <el-table-column prop="appscret"  label="appscret" ></el-table-column>
                <el-table-column prop="token"  label="token" sortable  width="80"></el-table-column>
                <el-table-column prop="mchId"  label="mchId" sortable  width="100"></el-table-column>
                <el-table-column prop="gzKeyword"  label="关注推送关键字" sortable >
                </el-table-column>
                <el-table-column prop="defaultKeyword"  label="默认回复关键字" sortable  ></el-table-column>
                <el-table-column label="操作" fixed="right" width="180">
                    <template slot-scope="scope">
                        <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.weixinBaseId ></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId"  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="appid">
                    <el-input v-model=form.appid clearable  placeholder="appid"></el-input>
                </el-form-item>
                <el-form-item label="appName">
                    <el-input v-model=form.appName ></el-input>
                </el-form-item>
                <el-form-item label="appscret">
                    <el-input v-model=form.appscret clearable  placeholder="appscret"></el-input>
                </el-form-item>
                <el-form-item label="token" >
                    <el-input v-model=form.token clearable  placeholder="token"></el-input>
                </el-form-item>
                <el-form-item label="mchId" >
                    <el-input v-model=form.mchId clearable  placeholder="mchId"></el-input>
                </el-form-item>
                <el-form-item label="payKey" >
                    <el-input v-model=form.payKey clearable  placeholder="payKey"></el-input>
                </el-form-item>
                <el-form-item label="关注Url" >
                    <el-input v-model=form.gzUrl clearable  placeholder="关注Url"></el-input>
                </el-form-item>
                <el-form-item label="客服电话" >
                    <el-input v-model=form.customerTel clearable  placeholder="客服电话"></el-input>
                </el-form-item>

                <el-form-item label="默认回复关键字" >
                    <el-select v-model="form.defaultKeywordId"  placeholder="默认回复关键字">
                        <el-option v-for="item in keywordData"
                                   :key="item.id"
                                   :label="item.keyword"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关注推送关键字" >
                    <el-select v-model="form.gzKeywordId"  placeholder="关注推送关键字">
                        <el-option v-for="item in keywordData"
                                   :key="item.id"
                                   :label="item.keyword"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>




                <el-form-item>

                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getWeiXinBaseList,saveWeiXinBase,getWeiXinBase} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                keywordData:[],
                loading:true,
                dialogFormVisible:false,
                form:{"weixinBaseId":0,"platformId":1,"appid":"","appscret":"","token":"","mchId":"","payKey":"","gzUrl":"",
                    "customerTel":"","defaultKeywordId":"","gzKeywordId":"","appName":""},
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                platformDisabled:false
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        methods:{
            //定义查询方法
            getList(){
                getWeiXinBaseList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.weiXinBaseList.total;
                    this.listData = res.data.weiXinBaseList.list;

                    this.platformData=res.data.platFormList;
                    //this.recordsTotal = res.data.total;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd(){
                //var d={id:0};
                this.dialogFormVisible = true;
                this.form.weixinBaseId=0;
                this.platformDisabled=false;
                this.form.platformId="";

                this.form.appid="";
                this.form.appName="";
                this.form.appscret="";
                this.form.token="";
                this.form.mchId="";
                this.form.payKey="";
                this.form.gzUrl="";
                this.form.customerTel="";
                this.form.defaultKeywordId="";
                this.form.gzKeywordId="";

                //this.handleEdit(d);
            },
            handleEdit(data){
                if(confirm("本操作可能造成系统问题，请谨慎修改，确认修改吗？")){
                    this.dialogFormVisible = true;
                    this.platformDisabled=true;
                    //得到实体
                    getWeiXinBase({weixinBaseId:data.weixinBaseId}).then((res) => {
                        //console.log(res.data);
                        if(res.data.value!=undefined) {
                            this.form = res.data.value.weixinBase;
                            this.keywordData=res.data.value.keywordList;
                        }

                    });
                }

            },
            save(data){
                console.log(data);
                if(data.appid==""){
                    this.$message({
                        message:"请输入appid",
                        type:'error'
                    });
                    return;
                }
                if(data.appName==""){
                    this.$message({
                        message:"请输入AppName",
                        type:'error'
                    });
                    return;
                }

                saveWeiXinBase(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }


                });

            },

        }
    }

</script>



// WEBPACK FOOTER //
// src/views/wechat/wechatBaseList.vue